<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    梧桐山南站<br>
站点介绍<br>
梧桐山南站位于深圳市罗湖区罗沙路北侧，车站呈东西走向。西接2号线莲塘站，东接沙头角站。 梧桐山南站为特色站，整体空间造型以“凤栖梧桐”为主要设计元素，楼扶梯洞口天花结合“凤镜、凤翎”打造一体化艺术灯具，为地下两层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设有4个出入口，临近罗湖区公安分局，梧桐山风景管理处。周边为成熟配套生活区，主要分布了长岭花园、惠兰雅居、东方风雅台、长岭村等住宅区、梧桐山风景区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:05	23:25	8号线	5分10秒	5分45秒<br>
盐田路	06:36	00:15	8号线	5分10秒	5分45秒<br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:25	8号线	4分钟	5分钟<br>
盐田路	06:36	00:15	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	00:15	8号线	4分钟	5分钟<br>
盐田路	06:36	01:15	8号线	4分钟	5分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
罗沙路北侧、深圳市公安局罗湖分局、深圳巴士集团、深圳市罗湖外语初中学校（东校区）<br><br>
A2出入口:<br>
七号路西侧（北）<br><br>
C1出入口:<br>
罗沙路北侧、梧桐山管理大楼<br><br>
D出入口:<br>
梧桐山南路东侧（北）、仙桐体育公园<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 公交站名<br>
罗湖公安分局<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>